import { createAction } from "@reduxjs/toolkit";
import type { FeaturesProperties } from "@/types/features";
import type { ThemeColorProperties } from "@/types/theme";

export type SettingsFromApiAppliedPayload = {
  features?: Partial<FeaturesProperties>;
  theme?: ThemeColorProperties;
};

/**
 * Single event: settings payload received from the API (features and/or theme).
 */
export const settingsFromApiApplied =
  createAction<SettingsFromApiAppliedPayload>("app/settingsFromApiApplied");
